import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../utils';
import type { ClassSelect } from '@org/model';
interface ClassHeaderProps {
  classInfo: ClassSelect;
  scrollProgress: number;
  children?: ReactNode;
}

export function ClassHeader({
  classInfo,
  scrollProgress,
  children,
}: ClassHeaderProps) {
  const { t } = useTranslation('p2e');
  return (
    <header
      className={cn(
        'space-y-6 rounded-xl border border-border p-6 shadow-sm transition-all duration-300',
        scrollProgress > 0.5 ? 'bg-card/95 backdrop-blur-sm' : 'bg-card',
      )}
    >
      {classInfo.imageUrl && (
        <img
          src={classInfo.imageUrl}
          alt={classInfo.name || 'Class'}
          className="h-80 w-full rounded-lg object-cover transition-opacity duration-300"
          style={{
            opacity: Math.max(1 - scrollProgress * 2, 0),
          }}
        />
      )}
      <div className="space-y-4">
        <p data-testid="class-overview-label" className="text-sm font-medium uppercase tracking-wide text-brand">{t('class.classOverview')}</p>
        <h1 className="text-3xl font-bold">{classInfo.name || 'Untitled Class'}</h1>
        {classInfo.description && <p className="text-lg text-muted-foreground">{classInfo.description}</p>}
      </div>
      {children}
    </header>
  );
}
